import React from "react";
import { LegacyCard, InlineGrid, TextField, Select } from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";

export const riverNumber = [
  { value: "MDC01", label: "MDC01" },
  { value: "MDC02", label: "MDC02" },
  { value: "MDC04", label: "MDC04" },
  { value: "MDC05", label: "MDC05" },
  { value: "MDC06", label: "MDC06" },
  { value: "MDC12", label: "MDC12" },
  { value: "MDC13", label: "MDC13" },
  { value: "MDC014", label: "MDC014" },
  { value: "MDC16", label: "MDC16" },
  { value: "MDC041", label: "MDC041" },
  { value: "MDC48", label: "MDC48" },
  { value: "MDC49", label: "MDC49" },
  { value: "MDC51", label: "MDC51" }
];

const MenJeanForm = ({
  form,
  setForm,
  errors,
  baseUrl,
  setApploader,
  conditionalFieldsMap,
}) => {
  const handleChange =
    (section, key = null) =>
      (values) => {
        const trimmedKey = key?.trim();
        let value;
        if (Array.isArray(values)) {
          value = values[0];
        } else {
          value = values;
        }

        const sectionMap = conditionalFieldsMap[section];
        const fieldRule = sectionMap?.[trimmedKey];

        if (fieldRule) {
          const { conditionValue, dependentKey } = fieldRule;
          if (value === conditionValue) {
            // Add the dependent field
            setForm((prev) => ({
              ...prev,
              [section]: {
                ...prev[section],
                [trimmedKey]: value,
                [dependentKey]: "",
              },
            }));
          } else {
            // Remove the dependent field
            const updatedSection = { ...form[section] };
            delete updatedSection[dependentKey];
            updatedSection[trimmedKey] = value;

            setForm((prev) => ({
              ...prev,
              [section]: updatedSection,
            }));
          }

          return;
        }
        // Default update
        if (trimmedKey) {
          setForm((prev) => ({
            ...prev,
            [section]: {
              ...prev[section],
              [trimmedKey]: value,
            },
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            [section]: value,
          }));
        }
      };

  const MenJeanFields = [
    {
      label: "Button",
      key: "Button",
      type: "select",
      options: ["GKC01", "GKC02", "GKC04", "GKC05", "GKC06", "GKC16", "CKC20", "CKC48", "GKC21", "GKC12", "GKC13", "GKC14", "GKC49", "GKC50"]
    },
    {
      label: "Thread",
      key: "thread",
      type: "select",
      options: ["A2750- WHITE", "A9383- SILVER", "A9694- GREY", "A9700- BLACK", "A7915- NAVY", "A1185- YELLOW", "A8322- CREAM", "A2315- TAN", "A2352- GOLD", "A8779- BROWN", "A3968- RED", "17ANT- LIME", "A5207- GREEN", "A7551- LT BLUE", "A7533- BLUE"]
    },
    {
      label: "Rivet",
      key: "rivet",
      type: "select",
      options: ["No", "Yes"],
    },
    {
      label: "Front Pocket",
      key: "frontPocket",
      type: "select",
      options: ["Crescent", "Slant", "Arc"]
    },
    {
      label: "Patch Pocket",
      key: "patchPocket",
      type: "select",
      options: ["Yes", "No"],
    },
    {
      label: "Back Pocket",
      key: "backPocket",
      type: "select",
      options: ["Pentagon", "Curved Pentagon", "Hexagon", "Rounded", "Single Welt", "Square"],
    },
    {
      label: "Washing Style",
      key: "washingStyle",
      type: "select",
      options: ["None", "Light", "Normal", "Heavy", "Wipe No Wiskers", "Chromatography", "Fried Salt"],
    },
  ];

  const handleFileUpload = async (section, key, file) => {
    const formData = new FormData();
    formData.append("image", file);
    setApploader(true);
    try {
      const res = await fetch(`${baseUrl}/api/files/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await res.json();
      if (res.ok) {
        const uploadedFilename = data.files;
        handleChange(section, key)(uploadedFilename);
        setApploader(false);
      } else {
        alert("File upload failed");
      }
    } catch (error) { }
  };

  const renderSection = (title, fields, sectionKey) => (
    <LegacyCard title={title} sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        {fields.map(({ label, key, type = "text", options = [] }) => {
          if (type === "select") {
            return (
              <React.Fragment key={key}>
                {key !== "liningNumber" && (
                  <div className="two_culumn">
                    <Select
                      label={label}
                      options={options}
                      value={form[sectionKey]?.[key] || ""}
                      onChange={handleChange(sectionKey, key)}
                      error={errors[sectionKey]?.[key]}
                    />
                    {key === "nameLabelFont" &&
                      form[sectionKey]?.[key] === "Custom Upload" && (
                        <input
                          type="file"
                          className="imgUpload"
                          key="nameLabelFontFile"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (!file) return;
                            handleFileUpload(
                              sectionKey,
                              "nameLabelFontFile",
                              file
                            );
                          }}
                          error={errors[sectionKey]?.["nameLabelFontFile"]}
                        />
                      )}
                    {key === "rivet" &&
                      form[sectionKey]?.[key] === "Yes" && (
                        <CustomAutocomplete
                          optionsList={riverNumber}
                          placeholder="Rivet Number"
                          onChange={handleChange(sectionKey, "riverNumber")}
                          defaultValue={form[sectionKey]?.['riverNumber'] || ""}
                        />
                      )}
                  </div>
                )}
                {key === "liningNumber" && (
                  <CustomAutocomplete
                    label={label}
                    optionsList={options}
                    onChange={handleChange(sectionKey, key)}
                    defaultValue={form[sectionKey]?.[key] || ""}
                  />
                )}
              </React.Fragment>
            );
          }
          return (
            <TextField
              key={key}
              label={label}
              value={form[sectionKey]?.[key] || ""}
              onChange={handleChange(sectionKey, key)}
              error={errors[sectionKey]?.[key]}
            />
          );
        })}
      </InlineGrid>
    </LegacyCard>
  );

  return renderSection("Men Jean", MenJeanFields, "menJean");
};

export default MenJeanForm;
